import { injectIntl } from 'react-intl';
import WriteOffRefund from './WriteOffRefund';

export default injectIntl(WriteOffRefund);
